import axios from '@/plugins/axios'

export default {

  async list () {
    return await axios.get('states')
  },

}
